import React from "react";
import ADDEMPModal from "../../../components/AdminComponents/addEmployeeButton";

import EmployeePropCon from "../../../components/AdminComponents/Table";

import TableLg from "../../../components/AdminComponents/Table";
import TableMd from "../../../components/AdminComponents/TableMd";
import { UseHrApp } from "../../../utils/context";
import { useEffect } from "react";

export default function Employees() {
  //#F2F2F2

  const { GetEmployees } = UseHrApp();

  useEffect(() => {
    GetEmployees();
  }, []);
  //<TableMd/>

  return (
    <div className=" min-w-screen min-h-[91vh] bg-[#f4f8fd] font-[Archivo]">
      <div className=" hidden md:block p-3 md:pl-[17em] lg:pl-[16em] xl:pl-[17em] md:pr-[2em] w-full pt-[1em] ">
        <div className=" w-full flex justify-between items-center mb-7">
          <p className=" font-[Archivo] lg:text-2xl font-semibold ">
            Employees
          </p>
          <ADDEMPModal />
        </div>

        <TableLg />
      </div>
      <div className=" md:hidden w-full min-h-[70vh] items-center redborder flex justify-center text-center pt-[5em] text-xl font-medium">
        <p>Please switch to a bigger screen</p>
      </div>
    </div>
  );
}
